export default "__VITE_ASSET__D0$Aycp4__"